import { searchLeaderboard } from '@neptune/shared/leaderboard-domain';

import { KnownAttributes } from 'domain/experiment/attribute';
import { AsyncActionsReturnType, createAsyncActions } from 'state/async-actions';

export enum LeaderboardCountActionTypes {
  request = 'LEADERBOARD_COUNT_FETCH',
  success = 'LEADERBOARD_COUNT_SUCCESS',
  fail = 'LEADERBOARD_COUNT_FAIL',
}

type FetchLeaderboardCountParams = {
  projectIdentifier: string;
};

const actions = createAsyncActions({
  types: LeaderboardCountActionTypes,
  async resolver(params: FetchLeaderboardCountParams) {
    return {
      projectIdentifier: params.projectIdentifier,
      leaderboard: await searchLeaderboard({
        projectIdentifier: params.projectIdentifier,
        pagination: {
          limit: 0,
          offset: 0,
        },
        experimentsOnly: false,
        type: ['run'],
        attributesToFetch: [KnownAttributes.Id],
      }),
    };
  },
});

export const { execute: fetchLeaderboardCount } = actions;

export type LeaderboardCountActions = AsyncActionsReturnType<typeof actions>;
